import TemplateFolderIcon from 'components/Icons/templateFolderIcon';
import ChecklistIcon from 'components/common/jsxrender/checklistV2/checklistGrid/ChecklistIcon';
import {
  FolderItem,
  TemplateItem,
  Content,
} from 'components/AllDialogs/templates/templatesWithFoldersHierarchy/FilesAndFoldersList/style';
import EmptyState from 'components/AllDialogs/templates/templatesSearch/EmptyFilter';
import { Box, Typography } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import CTypography from 'components/CTypography';
import { styled } from '@mui/material/styles';

interface FilesAndFoldersListProps {
  onTemplateSelect?: (templateId: string) => void;
  selectedTemplateId?: string | null;
  folders?: any[];
  templates?: any[];
  onFolderClick?: (folder: any) => void;
  searchTerm?: string;
}

function FilesAndFoldersList({
  onTemplateSelect,
  selectedTemplateId,
  folders = [],
  templates = [],
  onFolderClick,
  searchTerm,
}: FilesAndFoldersListProps) {
  const foldersData = folders.length > 0 ? folders : [];
  const templatesData = templates.length > 0 ? templates : [];

  const handleClickFolder = (folder) => {
    if (onFolderClick) {
      onFolderClick(folder);
    }
  };

  const handleClickTemplate = async (template) => {
    onTemplateSelect?.(template?.id);
  };

  const hasData = foldersData.length > 0 || templatesData.length > 0;
  const isSearchMode = searchTerm && searchTerm.length > 0;

  if (!hasData && !isSearchMode) {
    return <EmptyState />;
  }

  return (
    <Box sx={{ maxHeight: '400px', padding: '0 1px', overflowY: 'auto' }}>
      {foldersData.length > 0 && (
        <Box sx={{ mb: 2 }}>
          <Typography
            variant="h6"
            sx={{ py: 1, fontWeight: 600, color: '#212121' }}
          >
            Folders ({foldersData.length})
          </Typography>
          {foldersData.map((folder) => (
            <FolderItem
              key={folder.id}
              onClick={() => handleClickFolder(folder)}
            >
              <TemplateFolderIcon
                primaryColor={folder?.meta?.primaryColor}
                secondaryColor={folder?.meta?.secondaryColor}
              />
              <Content>
                <CTypography
                  className="title"
                  variant="body1"
                  sx={{ fontWeight: 500 }}
                >
                  {folder.title}
                </CTypography>
              </Content>
            </FolderItem>
          ))}
        </Box>
      )}

      {templatesData.length > 0 && (
        <Box>
          <Typography
            variant="h6"
            sx={{ py: 1, fontWeight: 600, color: '#212121' }}
          >
            Templates ({templatesData.length})
          </Typography>
          {templatesData.map((template) => (
            <TemplateItem
              key={template.id}
              onClick={() => handleClickTemplate(template)}
              className={selectedTemplateId === template?.id ? 'selected' : ''}
            >
              <ChecklistIcon
                icon={{
                  icon: template?.icon?.icon,
                  color: template?.icon?.color,
                }}
                sx={{ fontSize: '1rem' }}
              />
              <Content>
                <CTypography
                  className="title"
                  variant="body1"
                  sx={{ fontWeight: 500 }}
                >
                  {template.name}
                </CTypography>
                {template?.path?.length > 0 && (
                  <CTypography variant="caption" sx={{ color: '#757575' }}>
                    {template.path.map((pathItem, index) => (
                      <span key={pathItem.id}>
                        {pathItem.title}
                        {index < template.path.length - 1 ? ' > ' : ''}
                      </span>
                    ))}
                  </CTypography>
                )}
              </Content>
              {selectedTemplateId === template?.id && (
                <CheckIcon sx={{ color: '#6868FE' }} />
              )}
            </TemplateItem>
          ))}
        </Box>
      )}

      {!hasData && isSearchMode && (
        <Box sx={{ p: 3, textAlign: 'center' }}>
          <Typography variant="body1" color="text.secondary">
            No templates found for "{searchTerm}"
          </Typography>
        </Box>
      )}
    </Box>
  );
}

export default FilesAndFoldersList;
